import React, { Fragment } from 'react'

import BareBonesNavbar from '../BareBonesNavbar'
import Container from '../Container'
import Body from '../Body'

import styles from './styles'

/**
 * SceneLayout component
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.showNav]
 *
 * @returns {JSX.Element}
 */
const SceneLayout = ({ children, showNav = true }) => (
  <Fragment>
    <If condition={showNav}>
      <BareBonesNavbar />
    </If>
    <Body>
      <Container className={styles.container}>{children}</Container>
    </Body>
  </Fragment>
)

export default SceneLayout
